import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse from "html-react-parser";

const enum fields {
    propertyName = "propertyName",
    message = "message",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.propertyName]: string;
        [fields.message]: string;
    };
}

type Props = OwnProps & HasHistory & HasProduct;

const ProductDetailsWarningMessage: React.FC<Props> = props => {
    const { fields, product } = props;
    const message = typeof fields.message === "string" ? fields.message : "";

    if (product.properties[fields.propertyName] == "true") {
        return (
            <StyledWrapper>
                {message ? parse(message, parserOptions) : null}
            </StyledWrapper>
        );
    }
    return null;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsWarningMessage),
    definition: {
        displayName: "Product Details Warning Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.propertyName,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                sortOrder: 1,
            },
            {
                name: fields.message,
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                sortOrder: 2,
            }
        ],
    },
};

export default widgetModule;
